const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/appointment/components/AppointmentAddToCalendarRow.tsx';
import Grid from '@mui/material/Grid';
import * as React from 'react';
import { StructuredAppointment } from '@cistec/common_web/defs/kisim';
import { AddAppointmentToCalendar } from 'App/components/AddAppointmentToCalendar/AddAppointmentToCalendar';

type AppointmentAddToCalendarRowProps = {
    appointment: StructuredAppointment;
};

export const AppointmentAddToCalendarRow = (props: AppointmentAddToCalendarRowProps) => {
    const { appointment } = props;

    return (
        <Grid size={{ xs: 12 }}>
            <AddAppointmentToCalendar appointment={appointment} />
        </Grid>
    );
};
